import { useState, useEffect } from 'react';

interface NavbarProps {
  onApplyClick: () => void;
}

export default function Navbar({ onApplyClick }: NavbarProps) {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Para Quem', href: '#para-quem' },
    { label: 'Manifesto', href: '#manifesto' },
    { label: 'Experiência', href: '#experiencia' },
    { label: 'Palestrantes', href: '#palestrantes' },
    { label: 'Informações', href: '#informacoes' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? 'navbar-scrolled py-3' : 'py-5'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between">
        <a href="#" className="flex items-center whitespace-nowrap">
          <img
            src="https://storage.readdy-site.link/project_files/a8eed8a9-7380-4e8e-9ad5-85d3476c739a/e51c0938-15b8-4d24-be5d-53cf18fb5706_compressed_Ativo-1id.webp"
            alt="The Future Wedding"
            className="h-8 md:h-10 w-auto"
          />
        </a>

        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="text-xs tracking-[0.2em] uppercase transition-colors duration-300 whitespace-nowrap cursor-pointer"
              style={{
                color: scrolled ? 'oklch(var(--foreground-700))' : 'oklch(var(--background-50) / 0.85)',
              }}
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-4">
          <button
            onClick={onApplyClick}
            className="px-6 py-2.5 text-xs tracking-[0.15em] uppercase rounded-md transition-all duration-300 whitespace-nowrap cursor-pointer font-medium hover:opacity-90"
            style={{
              backgroundColor: '#ADC178',
              color: '#FFFFFF',
            }}
          >
            Garantir Vaga
          </button>
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Menu"
        >
          <i
            className={`ri-menu-line text-2xl transition-colors duration-300 ${
              scrolled ? 'text-foreground-900' : 'text-background-50'
            }`}
          ></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden absolute top-full left-0 right-0 navbar-scrolled py-6 px-6 flex flex-col gap-5">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={() => setMobileOpen(false)}
              className="text-xs tracking-[0.2em] uppercase text-foreground-700 whitespace-nowrap cursor-pointer"
            >
              {link.label}
            </a>
          ))}
          <button
            onClick={() => { onApplyClick(); setMobileOpen(false); }}
            className="mt-2 px-6 py-2.5 text-xs tracking-[0.15em] uppercase rounded-md transition-all duration-300 whitespace-nowrap cursor-pointer font-medium hover:opacity-90"
            style={{ backgroundColor: '#ADC178', color: '#FFFFFF' }}
          >
            Garantir Vaga
          </button>
        </div>
      )}
    </nav>
  );
}